import React, { useState, useEffect } from 'react';
import Table from '../../../../app/components/Table';
import Pagination from '../../../../app/components/Pagination';
import FormEditDepartment from '../../../../forms/Department/FormEditDepartment';
import Button from '../../../../app/components/Button';
import { FiPlus, FiEdit } from 'react-icons/fi';
import Toast from '../../../../app/components/Toast';


const Department = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [departments, setDepartments] = useState([]);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const showToast = (type, message) => {
    setToast({ show: true, type, message });
  };
  
  const itensPorPagina = 10;

  useEffect(() => {
    const storedDepartments = JSON.parse(localStorage.getItem('departments')) || [];
    setDepartments(storedDepartments);
  }, []);

  const saveDepartmentsToStorage = (updatedDepartments) => {
    setDepartments(updatedDepartments);
    localStorage.setItem('departments', JSON.stringify(updatedDepartments));
  };

  const gestoresOptions = [
    { id: 1, nome: 'Adriellen Neves' },
    { id: 2, nome: 'Allan' },
    { id: 3, nome: 'Ana Célia' },
    { id: 4, nome: 'Barbara Lima' },
    { id: 5, nome: 'Bruna Rodrigues' },
    { id: 6, nome: 'Celina Rosangela' },
  ];

  const handleEdit = (department) => {
    const nomes = typeof department.gestores === 'string'
      ? department.gestores.split(',').map((nome) => nome.trim())
      : [];

    const gestoresSelecionados = nomes
      .map((nome) => {
        const found = gestoresOptions.find((g) => g.nome === nome);
        return found ? found.id : null;
      })
      .filter(Boolean);

    setSelectedDepartment({
      ...department,
      gestores: gestoresSelecionados,
    });

    setIsFormOpen(true);
  };

  const getActionsForDepartment = (department) => [
    {
      icon: FiEdit,
      label: 'Editar',
      onClick: () => handleEdit(department),
    },
  ];

  const handlePageChange = (pagina) => setPaginaAtual(pagina);

  const handleNewDepartment = () => {
    setSelectedDepartment(null);
    setIsFormOpen(true);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
    setSelectedDepartment(null);
  };

  const handleFormSubmit = (formData) => {
    const nomesGestores = Array.isArray(formData.gestores)
      ? formData.gestores
          .map((id) => {
            const match = gestoresOptions.find((g) => g.id === id);
            return match ? match.nome : null;
          })
          .filter(Boolean)
          .join(', ')
      : formData.gestores;

    const novoDepartamento = {
      ...formData,
      gestores: nomesGestores,
    };

    let updatedDepartments;

    if (formData.id) {
      updatedDepartments = departments.map((dep) =>
        dep.id === formData.id ? { ...dep, ...novoDepartamento } : dep
      );
      showToast('success', 'Departamento editado com sucesso!');
    } else {
      const newId = Math.max(...departments.map((dep) => dep.id), 0) + 1;
      updatedDepartments = [...departments, { ...novoDepartamento, id: newId }];
      showToast('success', 'Novo departamento adicionado com sucesso!');

      const storedSequences = JSON.parse(localStorage.getItem('sequencesByCategory')) || {};
      storedSequences[novoDepartamento.nome] = storedSequences[novoDepartamento.nome] || [];
      localStorage.setItem('sequencesByCategory', JSON.stringify(storedSequences));
    }

    saveDepartmentsToStorage(updatedDepartments);
    setIsFormOpen(false);
  };


  const departmentsWithActions = departments.map((dep) => ({
    ...dep,
    acoes: getActionsForDepartment(dep),
  }));

  const colunas = [
    { titulo: 'ID', campo: 'id' },
    { titulo: 'NOME', campo: 'nome' },
    { titulo: 'EMAILS AGENDADOS', campo: 'emailsAgendados' },
    { titulo: 'GESTORES', campo: 'gestores' },
    { titulo: 'SOLICITAÇÕES', campo: 'disponivel', tipo: 'status' },
    { titulo: 'RESPONDER PARA', campo: 'responderPara' },
    { titulo: 'AÇÕES', tipo: 'acoes', centralizado: true },
  ];

  const renderizarStatus = (valor) => (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-medium ${
        valor ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
      }`}
    >
      {valor ? 'Ativo' : 'Inativo'}
    </span>
  );

  const totalPages = Math.ceil(departmentsWithActions.length / itensPorPagina);
  const indiceInicial = (paginaAtual - 1) * itensPorPagina;
  const indiceFinal = indiceInicial + itensPorPagina;
  const dadosPaginados = departmentsWithActions.slice(indiceInicial, indiceFinal);

  return (
    <div className="h-full w-full">
      <div className="flex justify-between items-center mb-6">
        <Button onClick={handleNewDepartment}>
          <FiPlus size={17} />
          Cadastrar
        </Button>
      </div>

      {departments.length === 0 ? (
        <div className="h-full w-full flex flex-col items-center justify-center text-center pt-24 text-sm">
          <p className="font-medium text-gray-500">Nenhuma automação configurada</p>
          <p className="text-gray-500">Adicione a primeira automação para "departamento".</p>
        </div>
      ) : (
        <>
          <div className="overflow-x-auto -mx-3 sm:mx-0">
            <Table
              colunas={colunas}
              dados={dadosPaginados}
              renderizarStatus={renderizarStatus}
            />
          </div>

          {departmentsWithActions.length > 0 && (
            <Pagination
              currentPage={paginaAtual}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              showPageNumbers={true}
              maxPageNumbers={5}
            />
          )}
        </>
      )}

      <FormEditDepartment
        isOpen={isFormOpen}
        onClose={handleFormClose}
        title={selectedDepartment ? 'Editar Departamento' : 'Novo Departamento'}
        selectDepartment={selectedDepartment}
        onSubmit={handleFormSubmit}
      />

      {toast.show && (
      <Toast
        type={toast.type}
        message={toast.message}
        duration={3000}
        onClose={() => setToast({ ...toast, show: false })}
      />
    )}
    </div>
  );
};

export default Department;
